<template>
    <div>
        <!--        <college-banner></college-banner>-->
        <div class="container">
            <div class="row">
                <div id="sidebar-main" class="col-md-4">
                    <div id="stream-main">
                        <iframe id="stream" frameborder="0" style="width: 100%; height: 300px"
                                allow="geolocation; microphone; camera">
                        </iframe>
                        <i class="fas fa-expand" @click="collapseMenu($event)"></i>
                    </div>
                    <div id="sidebar-inner-main" class="col-md-12">
                        <h3>Upload Notes Here</h3>
                        <form @submit.prevent="submitNotes($event)">
                            <label class="file" for="notes" id="drag-box" @dragenter="draggableStart($event)"
                                   @dragleave="draggableEnd($event)" @dragend="draggableEnd($event)"
                                   @dragstart="draggableStart($event)">
                                <input type="file" id="notes" @change="uploadNotes($event)"
                                       accept=".doc,.docx,.jpg,.jpeg,.png,.pdf,.xls,.xlsx" multiple>
                                <p>Drop a file or click to select one</p>
                            </label>
                            <ul id="files-list" class="hidden"></ul>
                            <div class="text-center">
                                <button type="submit" id="submit-notes" class="hidden ss-button">Upload</button>
                            </div>
                            <div id="loading-list">
                                <div class="loading-list loading-list2"></div>
                                <div class="loading-list-ring"></div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h1>Students Queries</h1>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <ul id="queries-list" class="comments-list quieries"
                                            style="min-height: 500px;"></ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row margin-top-40">
                <div class="col-md-8">
                    <div class="dash-inner-box">
                        <div class="dashboard-heading">
                            <div class="row">
                                <div class="col-md-12">
                                    <h1>Discussion</h1>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <ul id="comments-list-main" class="comments-list comments-main">

                                </ul>
                            </div>
                            <div class="col-md-12">
                                <div class="question-form">
                                    <textarea class="form-control" id="comment-field"></textarea>
                                    <div class="pull-right send-button">
                                        <a class="btn-send" @click="sendComment()" href="javascript:;">Send</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 margin-top-40">
                    <ul id="notes-list">
                        <li>Uploaded Notes List</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import toastr from '../../../public/js/toastr.js';
    import firebase from 'firebase';
    import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

    export default {
        data() {
            return {
                image: '',
                specialKey: 'BnE3860mWdnBEZMLXlwkdjw9A2K5DJ',
                db: firebase.database(),
                ref: '',
                classId: '',
                commentsList: [],
                monthDict: {
                    0: 'Jan',
                    1: 'Feb',
                    2: 'Mar',
                    3: 'Apr',
                    4: 'May',
                    5: 'June',
                    6: 'July',
                    7: 'Aug',
                    8: 'Sep',
                    9: 'Oct',
                    10: 'Nov',
                    11: 'Dec',
                },
            }
        },
        mounted() {
            var t = this;
            showLoader();

            function getUrlVars() {
                var vars = {};
                var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                    vars[key] = value;
                });
                return vars;
            }

            t.classId = getUrlVars()["cid"];
            var db = firebase.database();
            var ref = db.ref(t.specialKey + '/comments/' + t.classId);
            ref.on('value', gotData, errData);

            function gotData(data) {
                var result2 = [];
                for (var i in data.val()) {
                    result2.push([i, data.val()[i]]);
                }
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0])) {
                        if (result2[z][1].reply_to == "") {
                            t.showComment(result2[z][1].is_public, result2[z][0], result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                        }
                    }
                }
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0])) {
                        if (result2[z][1].reply_to != "") {
                            t.showReply(result2[z][0], result2[z][1].reply_to, result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                        }
                    }
                }
                // var data = data.val();
                // var keys = Object.keys(data);
            }

            function errData(data) {
                console.log('err');
            }

            var commentsRef = t.db.ref(t.specialKey + '/comments/');
            commentsRef.on('child_changed', function (data) {
                var result2 = [];
                for (var i in data.val()) {
                    result2.push([i, data.val()[i]]);
                }
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0])) {
                        if (result2[z][1].reply_to == "" && result2[z][1].sender == t.$store.getters.getUser['user_id'] || result2[z][1].is_public == true) {
                            t.showComment(result2[z][1].is_public, result2[z][0], result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                        }
                    } else {
                        if (result2[z][1].reply_to == "" && result2[z][1].sender == t.$store.getters.getUser['user_id'] || result2[z][1].is_public == true) {
                            var el = document.getElementById(result2[z][0]);
                            var data_key = el.getAttribute('data-key');
                            if (data_key != result2[z][0]) {
                                document.getElementById(result2[z][0]).remove();
                                t.showComment(result2[z][1].is_public, result2[z][0], result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                            }
                        }
                    }
                }
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0]) && document.getElementById(result2[z][1].reply_to)) {
                        if (result2[z][1].reply_to != "") {
                            t.showReply(result2[z][0], result2[z][1].reply_to, result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                        }
                    }
                }
            });
            var ref = db.ref(t.specialKey + '/notes/' + t.classId);
            ref.on('value', gotData1, errData1);

            function gotData1(data) {
                var result2 = [];
                for (var i in data.val()) {
                    result2.push([i, data.val()[i]]);
                }
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0])) {
                        t.showNotes(result2[z][0], result2[z][1].name, result2[z][1].file);
                    }
                }
            }

            function errData1(data) {
                console.log('err');
            }

            var user = this.$store.getters.getUser;
            var url = this.$store.getters.getDomain;

            var id = getUrlVars()["id"];
            if (this.$store.getters.getUserType == 'teacher' && id != "") {
                document.getElementById("stream").src = "https://sneh.eygb.me/live-stream/broadcast/" + id + "?uid=" + this.$store.getters.getUser['user_id'];
                setTimeout(function () {
                    hideLoader();
                }, 1500)
            } else {
                this.$router.push({path: '/dashboard'})
            }
            $('#queries-list').perfectScrollbar();
            $('#comments-list-main').perfectScrollbar();
            // window.addEventListener('beforeunload', function (e) {
            //     e.preventDefault();
            //     e.returnValue = '';
            // });
            t.initializeEvents();
        },
        methods: {
            collapseMenu(e) {
                var element = e.currentTarget;
                if (element.classList.contains("fa-expand")) {
                    element.classList = 'fas fa-compress';
                    document.getElementById('sidebar-main').classList = '';
                    document.getElementById('sidebar-inner-main').classList = 'col-md-4';
                    document.getElementById('stream').style.height = '500px';
                } else {
                    element.classList = 'fas fa-expand';
                    document.getElementById('sidebar-main').classList = 'col-md-4';
                    document.getElementById('sidebar-inner-main').classList = 'col-md-12';
                    document.getElementById('stream').style.height = '300px';
                }
            },
            uploadNotes() {
                var elem = document.getElementById('notes');
                var files = elem.files;
                var parent = elem.nextSibling;
                document.getElementById('drag-box').classList.remove('draggable');
                if (files.length < 1 || files.length > 10) {
                    document.getElementById('files-list').classList = "hidden";
                    document.getElementById('submit-notes').classList = "hidden";
                    parent.innerHTML = 'Drop a file or click to select one';
                    if (files.length > 10) {
                        alert('Max 10 files can be uploaded at one time.');
                    }
                    return;
                }
                document.getElementById('submit-notes').classList = "ss-button";
                document.getElementById('files-list').innerHTML = "";
                if (files.length == 1) {
                    parent.innerHTML = files[0].name;
                } else {
                    document.getElementById('files-list').insertAdjacentHTML("beforeend", '<li>Notes List</li>');
                    for (var l = 0; l < files.length; l++) {
                        var template = '<li>' + files[l].name + '</li>';
                        document.getElementById('files-list').insertAdjacentHTML("beforeend", template);
                    }
                    document.getElementById('files-list').classList = "";
                    parent.innerHTML = 'Multiple Files';
                }
            },
            sendComment() {
                var t = this;
                var currentDate = new Date();
                var senddate = currentDate.getDate() + " " + t.monthDict[currentDate.getMonth()] + " " + currentDate.getFullYear();
                var getMins = currentDate.getMinutes();
                if (getMins < 10) {
                    getMins = "0" + getMins;
                }
                var sendtime = currentDate.getHours() + ":" + getMins;
                var ques = document.getElementById('comment-field').value;
                if (ques != '') {
                    var uId = t.uniqueId();
                    var name = this.$store.getters.getUser['first_name'] + ' ' + this.$store.getters.getUser['last_name'];
                    var image = this.$store.getters.getUser['image'];
                    var ref = t.db.ref(this.specialKey + '/comments/' + t.classId + '/' + uId);
                    ref.set({
                        'name': name,
                        'sender': t.$store.getters.getUser['user_id'],
                        'is_public': true,
                        'reply_to': "",
                        'comment': ques,
                        'image': image,
                        'date': senddate,
                        'time': sendtime,
                    });
                    t.saveComment(uId, ques);
                    document.getElementById('comment-field').value = "";
                } else {
                    alert('Enter Question to send');
                }
            },
            sendReply(message, id) {
                var t = this;
                var currentDate = new Date();
                var senddate = currentDate.getDate() + " " + t.monthDict[currentDate.getMonth()] + " " + currentDate.getFullYear();
                var getMins = currentDate.getMinutes();
                if (getMins < 10) {
                    getMins = "0" + getMins;
                }
                var sendtime = currentDate.getHours() + ":" + getMins;
                var uId = t.uniqueId();
                var name = this.$store.getters.getUser['first_name'] + ' ' + this.$store.getters.getUser['last_name'];
                var image = this.$store.getters.getUser['image'];
                var ref = t.db.ref(this.specialKey + '/comments/' + t.classId + '/' + uId);
                ref.set({
                    'name': name,
                    'sender': t.$store.getters.getUser['user_id'],
                    'reply_to': id,
                    'comment': message,
                    'image': image,
                    'date': senddate,
                    'time': sendtime,
                });
                t.saveComment(uId, message, id);
            },
            moveToComments(id) {
                var t = this;
                t.db.ref(this.specialKey + '/comments/' + t.classId + '/' + id + '/is_public').set(true);
                var url = this.$store.getters.getDomain;

                var data = {'comment_enc_id': id, 'value': 1};
                axios.post(`${url}api/v2/classes/change-visibility`, data, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        toastr.success('Query Moved to Comments', 'Success');
                    } else {
                        toastr.error('An Error Occurred Try Again', 'Oops!!');
                    }
                });
            },
            saveComment(id, question, reply_to = null) {
                var t = this;
                var url = this.$store.getters.getDomain;

                var data = {'id': id, 'class_id': t.classId, 'comment': question}
                if (reply_to) {
                    data['reply_to'] = reply_to;
                }
                axios.post(`${url}api/v2/classes/save-comment`, data, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        toastr.success('Query Send', 'Success');
                    } else {
                        toastr.error('An Error Occurred Try Again', 'Oops!!');
                    }
                });
            },
            submitNotes() {
                var t = this;
                var url = this.$store.getters.getDomain;

                var fadeTarget = document.getElementById("loading-list");
                fadeTarget.style.display = "block";
                var files = document.getElementById('notes').files;
                let formData = new FormData();

                for (var i = 0; i < files.length; i++) {
                    let file = files[i];
                    formData.append('files[' + i + ']', file);
                }
                formData.append('class_id', t.classId);
                var data = {'class_id': t.classId, 'notes': formData}
                axios.post(`${url}api/v2/classes/upload-notes`, formData, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        toastr.success('Notes Uploaded', 'Success');
                        if (response['data']['response']['data'].length) {
                            for (var n = 0; n < response['data']['response']['data'].length; n++) {
                                var uId = t.uniqueId();
                                var ref = t.db.ref(t.specialKey + '/notes/' + t.classId + '/' + uId);
                                ref.set({
                                    'sender': t.$store.getters.getUser['user_id'],
                                    'file': response['data']['response']['data'][n].link,
                                    'name': response['data']['response']['data'][n].title,
                                });
                            }
                        }
                        document.getElementById('notes').value = "";
                        t.uploadNotes();
                    } else {
                        toastr.error('An Error Occurred Try Again', 'Oops!!');
                    }
                    var fadeTarget = document.getElementById("loading-list");
                    fadeTarget.style.display = "none";
                });
            },
            showNotes(id, name, file) {
                var template = '<li id="' + id + '"><a href="' + file + '" target="_blank" download>' + name + '</a></li>';
                document.getElementById('notes-list').insertAdjacentHTML("beforeend", template);
            },
            getComments() {
                var t = this;
                var url = this.$store.getters.getDomain;

                var data = {class_id: t.classId}
                axios.post(`${url}api/v2/classes/get-parent-comments`, data, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        if (response['data']['response']['comments'].length) {
                            t.commentsList = response['data']['response']['comments'];
                            t.initializeEvents();
                        }
                    }
                });
            },
            showComment(visibility, id, name, message, date, image) {
                if (visibility) {
                    var template = '<li id="' + id + '" data-key="' + id + '"><div class="comment-main-level"><div class="comment-avatar"><img src="' + image + '" alt=""></div><div class="comment-box"><div class="comment-head"><h6 class="comment-name"><a href="#">' + name + '</a></h6><span class="posted-time">Posted on ' + date + '</span></div><div class="comment-content">' + message + '<div class="comment-open"><a class="btn-reply">Reply</a></div></div><div class="comment-footer"><div class="comment-form"><textarea class="form-control" name=""></textarea><div class="pull-right send-button"><a class="btn-send send-reply">Send</a></div></div></div></div></div><ul class="comments-list quieries reply-list"></ul></li>';
                    document.getElementById('comments-list-main').insertAdjacentHTML("beforeend", template);
                } else {
                    var template = '<li id="' + id + '"><div class="comment-main-level"><div class="comment-avatar"><img src="' + image + '" alt=""></div><div class="comment-box"><div class="comment-head"><h6 class="comment-name"><a href="#">' + name + '</a></h6><span class="posted-time">Posted on ' + date + '</span><i class="fas fa-sign-out-alt move-to-comments" title="Show in Comments"></i></div><div class="comment-content">' + message + '<div class="comment-open"><a class="btn-reply">Reply</a></div></div><div class="comment-footer"><div class="comment-form"><textarea class="form-control" name=""></textarea><div class="pull-right send-button"><a class="btn-send send-reply">Send</a></div></div></div></div></div><ul class="comments-list quieries reply-list"></ul></li>';
                    document.getElementById('queries-list').insertAdjacentHTML("beforeend", template);
                }
            },
            showReply(id, parent, name, message, date, image) {
                var template = '<li id="' + id + '"><div class="comment-avatar"><img src="' + image + '"></div> <div class="comment-box"> <div class="comment-head"><h6 class="comment-name"><a href="javascript:;">' + name + '</a></h6> <span class="posted-time">Posted on ' + date + '</span> </div> <div class="comment-content"> ' + message + '</div> </div> </li>';
                document.getElementById(parent).childNodes[1].insertAdjacentHTML("beforeend", template);
            },
            initializeEvents() {
                var t = this;
                $(document).on('click', '.btn-reply', function (eve) {
                    eve.preventDefault();
                    $(this).parent().parent().siblings('.comment-footer').slideToggle();
                    eve.stopImmediatePropagation();
                });
                $(document).on('click', '.send-reply', function (eve) {
                    eve.preventDefault();
                    var targetObject = $(this).parent().parent().parent().parent().parent();
                    var textarea = $(this).parent().siblings('textarea');
                    var reply_text = $(this).parent().siblings('textarea').val();
                    if ($.trim(reply_text) == " " || $.trim(reply_text) == "") {
                        alert("insert comment");
                    } else {
                        if ($(targetObject).hasClass("comment-main-level")) {
                            if ($(targetObject).siblings('.comments-list.quieries.reply-list')) {
                                // var element_prepend = '<li><div class="comment-avatar"><img alt="" src="http://dummyimage.com/60"></div><div class="comment-box"> <div class="comment-head"> <h6 class="comment-name"><a href="#">You</a></h6> <span class="posted-time">Posted on DD-MM-YYYY HH:MM</span></div><div class="comment-content">'+ reply_text +'</div></div></li>';
                                // $(targetObject).siblings('.comments-list.reply-list').prepend(element_prepend);
                                var r_id = $(targetObject).parent('li').attr('id');
                                textarea.val('');
                                t.sendReply(reply_text, r_id);
                            }
                        }
                    }
                });
                $(document).on('click', '.move-to-comments', function (e) {
                    e.preventDefault();
                    var id = $(this).parentsUntil('li').parent('li').attr('id');
                    t.moveToComments(id);
                });
            },
            uniqueId() {
                var result = '';
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for (var i = 0; i < 15; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return this.$store.getters.getUser['user_id'] + result;
            },
            draggableStart(e) {
                if (!document.getElementById('drag-box').classList.contains('draggable')) {
                    document.getElementById('drag-box').classList += ' draggable';
                }
            },
            draggableEnd(e) {
                document.getElementById('drag-box').classList.remove('draggable');
            },
        },
        beforeRouteLeave(to, from, next) {
            if (to.name) {
                const answer = window.confirm('Do you really want to leave this page?')
                if (answer) {
                    next()
                } else {
                    next(false)
                }
            } else {
                next()
            }

        }
    }
</script>
<style>
    #stream-main {
        position: relative;
    }

    #stream-main i {
        position: absolute;
        bottom: 15px;
        right: 15px;
        font-size: 18px;
        color: #fff;
        cursor: pointer;
    }

    ul {
        list-style-type: none;
    }

    #sidebar-inner-main > form {
        position: relative;
    }

    #files-list {
        border: 1px solid #ddd;
    }

    #files-list li:first-child {
        font-size: 16px;
        text-align: center;
        font-weight: 600;
    }

    #files-list li {
        padding: 10px;
        border-bottom: 1px solid #ddd;
    }

    #files-list li a {
        word-break: break-all;
    }

    #files-list li:last-child {
        border-bottom: 0px;
    }

    label.file {
        position: relative;
        display: block;
        width: 100%;
        font-size: 80%;
        text-align: center;
        text-transform: uppercase;
        border: 2px dashed #ccc;
        margin: 2rem 0;
        padding: 5rem;
    }

    label.file:hover, label.draggable {
        background-color: rgba(255, 255, 255, 0.3);
        border-color: #00a0e3;
        box-shadow: 0px 1px 10px 1px #ddd;
    }

    label.file:active,
    label.file.focus {
        border-color: #09f;
    }

    input#notes {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        outline: 0;
        border: 1px solid red;
        z-index: 9;
    }

    .loading-list2 {
        top: 0;
        z-index: 10;
    }
</style>